/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * In-flight request deduplication to prevent duplicate simultaneous requests.
 */

const inFlightRequests = new Map<string, Promise<unknown>>();

/**
 * Run an async function once per key. Concurrent callers with the same key
 * share the same promise; when it completes, the key is removed.
 */
export function runDeduplicated<T>(
  key: string,
  fn: () => Promise<T>,
): Promise<T> {
  const existing = inFlightRequests.get(key);
  if (existing) return existing as Promise<T>;
  const promise = fn().finally(() => {
    inFlightRequests.delete(key);
  });
  inFlightRequests.set(key, promise);
  return promise as Promise<T>;
}
